// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Otis Kit PRO components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Otis Kit PRO examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";


function TestimonialsOne() {
    const emit = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCdCVVtAphSK_mPIvf6-vWk3Lm6b87irA_3Q&s"
    const bacc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDpzCu6jjym7QD-SUsMR2p9XPYAyz8b1X1qw&s"
    return (
        <MKBox component="section" py={6}>
            <Container>
                <Grid container item xs={12} lg={6} justifyContent="center" mx="auto" textAlign="center">
                    <MKTypography variant="h2" mb={2}>
                        Mes formations
                    </MKTypography>
                    <MKTypography variant="body2" color="text" mb={2}>
                        Découvrez mon parcours académique et professionnel, illustrant les diplômes obtenus, les compétences acquises et les connaissances développées au fil des années.
                    </MKTypography>
                </Grid>

                <Grid container spacing={3} mt={8}>
                    <Grid item xs={12} md={8} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultReviewCard

                            image={emit}
                            name="École de Management et d'Innovation Technologique - Université de Fianarantsoa"
                            date="2018"
                            review="Licence en Développement d'Applications Internet/Intranet (DAII)"
                            rating={3}
                        />
                    </Grid>
                    <Grid item xs={12} md={8} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultReviewCard
                            color="info"
                            image={emit}
                            name="École de Management et d'Innovation Technologique - Université de Fianarantsoa"
                            date="2020"
                            review="Ingénieur en Systèmes d'Information Géomatique et Décision (SIGD)"
                            rating={5}
                        />
                    </Grid>

                    <Grid item xs={12} md={8} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultReviewCard
                            image={bacc}
                            name="Lycée privé St Louis, Ambositra"
                            date="2015"
                            review="Bachelier, Série D"
                            rating={1}
                        />
                    </Grid>
                </Grid>


            </Container>
        </MKBox>
    );
}

export default TestimonialsOne;